export default __webpack_public_path__ + "static/media/t2.537019ab.jpeg";